import Progress from "./Progress.component";

export default Progress;
